import { render, staticRenderFns } from "./Aste.vue?vue&type=template&id=7d028e5a&scoped=true"
import script from "./Aste.vue?vue&type=script&lang=ts"
export * from "./Aste.vue?vue&type=script&lang=ts"
import style0 from "./Aste.vue?vue&type=style&index=0&id=7d028e5a&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d028e5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ldemenego\\REPOS\\VUEJS\\configuratore-demenego-v2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d028e5a')) {
      api.createRecord('7d028e5a', component.options)
    } else {
      api.reload('7d028e5a', component.options)
    }
    module.hot.accept("./Aste.vue?vue&type=template&id=7d028e5a&scoped=true", function () {
      api.rerender('7d028e5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Aste.vue"
export default component.exports